import { gql } from 'apollo-boost'

export const createCustomerMutation = gql`
  mutation createCustomer($input:CreateCustomerInput!) {
    createCustomer(input:$input) {
      firstName
      lastName
    }
  }
`